var render = function render(){var _vm=this,_c=_vm._self._c;return _c('searchable-grid',{attrs:{"title":"Transactions","fixed-height":_vm.fixedHeight,"column-defs":_vm.columnDefs,"get-rows-promise":_vm.getRows},on:{"cellDoubleClicked":_vm.onCellDoubleClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }